const escapeRegex = (string = '') => string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

export const diacriticSpaceSensitiveRegex = (string = '') => {
  const pattern = escapeRegex(string)
    .toLowerCase()
    .replace(/[aáàã]/g, '[aáàã]')
    .replace(/[eé]/g, '[eé]')
    .replace(/[ií]/g, '[ií]')
    .replace(/[oó]/g, '[oó]')
    .replace(/[uú]/g, '[uú]')
    .replace(/[cç]/g, '[cç]')
    .replace(/[\s\-_]/g, '[\\s\\-\\_]')
    .replace(/%/g, '.*')

  try {
    return new RegExp(pattern, 'ig')
  } catch {
    return new RegExp(escapeRegex(string).toLowerCase(), 'ig')
  }
}
